import { createAction, props } from '@ngrx/store';

export const orderBumpAddProduct = createAction('[OrderBump] add product', props<{ product_id: number }>());

export const orderBumpRemoveProduct = createAction('[OrderBump] remove product', props<{ product_id: number }>());
